import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { useDebouncedValue, useDisclosure } from "@mantine/hooks";
import { IconSearch } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import { modals } from "@mantine/modals";
import { IconEdit } from "@tabler/icons-react";

import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { getListProductAddOn } from "../../../api/ApiProductAddOn";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";

const ProductAddOn = () => {
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });

  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  // data tất cả dữ liệu thương hiệu sản phẩm
  const [dataBrand, setDataBrand] = useState<any[]>();

  //   format tiền
  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const [searchValue, setSearchValue] = useState(""); // Giá trị tìm kiếm gốc
  const [debouncedSearchValue] = useDebouncedValue(searchValue, 400);

  const formSeachInput = useForm<{
    KeySearch: string;
  }>({
    mode: "uncontrolled",
  });

  // console.log("formSeachInput", formSeachInput.getValues());

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 70,
      },
      {
        accessorKey: "itemCodeAddon",
        header: "Mã dịch vụ",
        size: 130,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Tooltip label="Xem chi tiết">
              <Badge
                variant="dot"
                radius="xs"
                style={{
                  cursor: "pointer",
                }}
                size="lg"
              >
                {renderedCellValue}
              </Badge>
            </Tooltip>
          </>
        ),
      },
      {
        accessorKey: "addonItemName",
        header: "Tên dịch vụ",
        size: 550,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "unitSellingPrice",
        header: "Giá",
        size: 550,
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },

      {
        accessorKey: "itemCode",
        header: "Mã SP được áp dụng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 190,
      },

      {
        accessorKey: "createTime",
        header: "Thời gian tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>
            <Text size="sm">
              {renderedCellValue && formatDateTransfer(renderedCellValue)}
            </Text>
          </>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 140,
        Cell: ({ renderedCellValue, row }) => (
          <Flex direction={"column"} gap={7}>
            <EuiFlexGroup
              responsive={true}
              wrap={false}
              gutterSize="s"
              alignItems="center"
              justifyContent="center"
            >
              <EuiFlexItem grow={false}>
                {/* <Tooltip label="Cập nhật đặc điểm sản phẩm">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="violet"
                  >
                    <IconReload size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip> */}
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <Tooltip label="Chỉnh sửa">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="green"
                  >
                    <IconEdit />
                  </ActionIcon>
                </Tooltip>
              </EuiFlexItem>
            </EuiFlexGroup>
          </Flex>
        ),
      },
    ],
    [dataBrand, data]
  );

  // Hàm kiểm tra
  // const handleEditData = async (id: number) => {
  //   if (id) {
  //     editItem(id, type);
  //   } else {
  //     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //   }
  // };

  //
  const handleGoToEditAttribute = (idAttr: number) => {
    modals.closeAll();
    navigate("/attribute", { state: { id: idAttr } });
  };

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        right: ["action"],
      },
      // columnVisibility: { id: true },
      density: "xs",
    },
    enableStickyFooter: true,
    enableRowSelection: false,
    enableToolbarInternalActions: false,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: 550,
        fontSize: "12px",
        padding: "6px 8px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  //lấy data list sp
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    try {
      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;
      const search = formSeachInput.getValues();
      const keySearchObj = {
        KeySearch: search.KeySearch?.trim().toLowerCase() || "",
      };
      // Xây dựng URL từ keySearchObj
      Object.entries(keySearchObj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            url += `&${key}=${encodeURIComponent(item)}`;
          });
        } else if (value) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      let response = await getListProductAddOn(url);
      if (response && response.success) {
        setData(response.data);
        setRowCount(response.totalCount);
      }
      table.resetRowSelection();
    } catch (error: any) {
      setData([]);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box pos={"relative"}>
      <Flex
        gap="md"
        justify={"space-between"}
        align="center"
        direction="row"
        wrap="wrap"
        w={"100%"}
      >
        <BreadCrumb></BreadCrumb>
        {/* <AppAction
          // openModal={openModal}
          // openModalDelete={openModalDelete}
          // openModalEdit={openModalEdit}
          isUpdateSearchItem={true}
          // openModalupdateExel={openModalupdateExel}
          exportExcel={exportExcel}
        ></AppAction> */}
      </Flex>

      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
        ref={headerRef}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Grid style={{ width: "100%" }} mt={10}>
            <Grid.Col span={sizeGrid}>
              <TextInput
                size="md"
                width="100%"
                placeholder="Từ khoá"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("KeySearch")}
                {...formSeachInput.getInputProps("KeySearch")}
              />
            </Grid.Col>
            {/* <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Chọn ngày bắt đầu"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                key={formSeachInput.key("StartTime")}
                {...formSeachInput.getInputProps("StartTime")}
                value={
                  formSeachInput.getValues().StartTime
                    ? dayjs(formSeachInput.getValues().StartTime).toDate()
                    : null // Nếu không có giá trị, đặt null
                }
                onChange={(date) =>
                  formSeachInput.setFieldValue(
                    "StartTime",
                    date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                  )
                }
                clearable
              />
            </Grid.Col> */}

            {/* <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Chọn ngày kết thúc"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                maxDate={
                  formSeachInput.getValues().StartTime
                    ? addMonths(
                        new Date(formSeachInput.getValues().StartTime),
                        1
                      )
                    : undefined
                }
                key={formSeachInput.key("EndTime")}
                {...formSeachInput.getInputProps("EndTime")}
                value={
                  formSeachInput.getValues().EndTime
                    ? dayjs(formSeachInput.getValues().EndTime).toDate()
                    : null
                }
                onChange={(date) =>
                  formSeachInput.setFieldValue(
                    "EndTime",
                    date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                  )
                }
                clearable
              />
            </Grid.Col> */}

            <Grid.Col span={sizeGrid}>
              <Button
                type="submit"
                leftSection={<IconSearch size={20} />}
                color="blue"
                size="md"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Box>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ProductAddOn;
